import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router";


const RecentIssue = ({
  list,
  questionId,
  calculateSum,
  onChildStateChange,
  listItems,
  totalSum,
  setListItems,
}) => {
  const navigate = useNavigate();
  const selectedClientId = useSelector((state) => state.selectedClientId);
  const [loading, setLoading] = useState(false);

  // State for storing list items and their respective dropdown values
  // const [listItems, setListItems] = useState(list);

  // useEffect(() => {
  //   // calculateSum();
  //   sendDataToParent();
  // }, [listItems]);

  // useEffect(() => {
  //   setListItems(list);
  // }, [list]);

  // State for storing the total sum
  // const [totalSum, setTotalSum] = useState(0);

  // Function to handle change in dropdown values
  const handleRadioChange = (itemId, value) => {
    // Find the item in the items array
    const updatedItems = listItems.map((item) => {
      if (item.id === itemId) {
        // Update the value of the selected radio button
        return { ...item, value };
      }
      return item;
    });

    //onChildStateChange(updatedItems);
    setListItems(updatedItems);
  };

  // Calculate the sum of all selected values
  // const calculateSum = () => {
  //   const sum = listItems.reduce((acc, item) => acc + item.value, 0);
  //   setTotalSum(sum);
  // };

  const sendDataToParent = () => {
    // onDataFromChild(inputValue);
    calculateSum(listItems);
  };

  return (
    <div className="ACE_main_table mt-4">
      <div>
      <div className="head-6">Recent Issues</div>
        <label className="pb-3 mt-2">
          Since you marked YES to at least one item above, please complete this
          section. Mark the answer that corresponds with how often the item has
          bothered the child in the last two weeks.
        </label>
      </div>
      <div className="row border-bottom mb-3">
        <div className="col-12">
          <label className="fw-500">
            NOTE: 0 = Never; 1 = Once in a while; 2 = Half the time; 3 = Almost
            always
          </label>
        </div>
        {/* <div className="col-12  select_table_phq cus-select-table-drops">
          <div className="strongly_main ml-auto align-items-center">
            <div className="strongly-disagree">
              <div class="flex-text custom-flex-text align-items-center">
                <div className="data-zero ml-3" style={{marginRight:'35px'}}>
                  <p>0</p>
                </div>
                <div className="data-one" style={{marginRight:'35px'}}>
                  <p>1</p>
                </div>
                <div className="data-one" style={{marginRight:'35px'}}>
                  <p>2</p>
                </div>
                <div className="data-one" style={{marginRight:'35px'}}>
                  <p>3</p>
                </div>
              </div>
            </div>
          </div>
        </div> */}
      </div>
      {listItems.map((item) => (
        <div className="row mb-3 pb-2 border-bottom">
          <div className="col-12">
            <div key={item.id}>
              <label>
                {item.id}. {item.name}
              </label>
            </div>
          </div>
          <div className="col-12  select_table_phq cus-select-table-drops">
            {[0, 1, 2, 3].map((value) => (
              <label key={value} className="cats_label">
                <input
                  type="radio"
                  name={`item${item.id}`}
                  value={value}
                  checked={item.value == value}
                  onChange={() => handleRadioChange(item.id, value)}
                  className="mr-2 mb-0 ml-2"
                />
                <span>{value}</span>
              </label>
            ))}
          </div>
        </div>
      ))}
      <div className="text-start justify-content-start total_phq col-12">
        <label>Total Score: </label>
        <p className="submitButon mb-0"> {totalSum}</p>
      </div>
    </div>
  );
};

export default RecentIssue;
